<template>
    <div :class="customClass ? `${customClass}` : 'block'">
        <slot name="operation"></slot>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 40, 60, 80]"
            :page-size="20"
            layout="total, prev, pager, next,sizes"
            :total="total"
        >
        </el-pagination>
    </div>
</template>

<script>
// 分页组件
export default {
    components: {},
    props: {
        customClass: String,
        total: Number
    },
    data() {
        return {
            currentPage: 1
        };
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('handleSizeChange', 'rows', val);
        },
        handleCurrentChange(val) {
            this.$emit('handleCurrentChange', 'page', val - 1);
        }
    }
};
</script>
<style scoped lang="scss">
.block {
    background: #fff;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-content: center;
}
.alone {
    text-align: right;
    background: #fff;
    padding: 20px;
    position: relative;
}
.icon-daochu {
    color: #107c41;
    position: absolute;
    left: 20px;
    top: 30px;
    cursor: pointer;
}
</style>
